import { render, staticRenderFns } from "./SearchMenuItemResults.vue?vue&type=template&id=37f6d56b"
import script from "./SearchMenuItemResults.vue?vue&type=script&lang=ts"
export * from "./SearchMenuItemResults.vue?vue&type=script&lang=ts"
import style0 from "./SearchMenuItemResults.vue?vue&type=style&index=0&id=37f6d56b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports